import { render, staticRenderFns } from "./OrderFlowCmp.vue?vue&type=template&id=6db40757&scoped=true&"
import script from "./OrderFlowCmp.vue?vue&type=script&lang=js&"
export * from "./OrderFlowCmp.vue?vue&type=script&lang=js&"
import style0 from "./OrderFlowCmp.vue?vue&type=style&index=0&id=6db40757&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db40757",
  null
  
)

export default component.exports